import { render, staticRenderFns } from "./ChiefComplaint.vue?vue&type=template&id=51bca588&scoped=true"
import script from "./ChiefComplaint.vue?vue&type=script&lang=js"
export * from "./ChiefComplaint.vue?vue&type=script&lang=js"
import style0 from "./ChiefComplaint.vue?vue&type=style&index=0&id=51bca588&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bca588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51bca588')) {
      api.createRecord('51bca588', component.options)
    } else {
      api.reload('51bca588', component.options)
    }
    module.hot.accept("./ChiefComplaint.vue?vue&type=template&id=51bca588&scoped=true", function () {
      api.rerender('51bca588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/ChiefComplaint.vue"
export default component.exports